import { useField } from "formik";
import React, { useMemo, useState } from "react";

import { capitalizeFirstLetter } from "../helpers/string";
import { useTranslate } from "../hooks/useTranslate";
import Icon from "./Icon";
import CustomInput from "./Input";
import joinClassNames from "../helpers/joinClassNames";
import OutSideClick from "./OutSideClick";
import PasswordStrength from "./PasswordStrength";

export function PasswordWithStrength({
                                         placeholder,
                                         name,
                                         type,
                                         maxLength,
                                         label,
                                         containerClassName,
                                         withEyeOption = false,
                                         format = value => value,
                                         afterOnChange,
                                     }) {
    const [field, meta, { setTouched, setValue }] = useField({
        name,
        type,
        placeholder,
    });
    const [eyeState, updateEyeState] = useState(false);
    const [translate] = useTranslate();
    const isError = meta.error && meta.touched && field.value;
    const [showStrength, updateShowStrength] = useState(false);

    const inputType = useMemo(() => {
        if (eyeState) return "text";
        return "password";
    }, [eyeState, name]);

    return (
        <OutSideClick
            isOpen={showStrength}
            onClick={() => updateShowStrength(false)}
        >
            <section className={containerClassName}>
                <section className="d-flex align-items-center justify-content-between">
                    <label>{label}</label>
                </section>

                <CustomInput
                    {...field}
                    onBlur={event => {
                        field.onBlur(event);
                    }}
                    onChange={event => {
                        setTouched(true);
                        setValue(format(event.target.value));
                        if (afterOnChange) {
                            afterOnChange();
                        }
                    }}
                    onFocus={() => {
                        updateShowStrength(true);
                    }}
                    type={inputType}
                    className={joinClassNames(isError && "is-invalid without-error-icon", "pr-12")}
                    maxLength={maxLength}
                    placeholder={placeholder}
                />

                {!!withEyeOption && (
                    <Icon
                        icon={"eye"}
                        onClick={() => updateEyeState(prevState => !prevState)}
                        className="input-eye-option"
                    />
                )}

                {field.value && showStrength && (
                    <PasswordStrength password={field.value} />
                )}

                {isError && !showStrength && (
                    <span className="invalid-feedback select-none">
            {capitalizeFirstLetter(
                translate(meta.error, {
                    label: label.toLowerCase(),
                }) ?? ""
            )}
          </span>
                )}
            </section>
        </OutSideClick>
    );
}
